var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    ref: "formPopup",
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      hasAlert: "",
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { "py-0": "", fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            "hide-details": "",
                            items: _vm.labelTemplates,
                            "return-object": "",
                            label: _vm.$t("template"),
                            "item-text": "name"
                          },
                          on: { change: _vm.applyLabelTemplate }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("sender")) + ": ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.fromAddress,
                                            name: "address-template-name",
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "key"
                                          },
                                          model: {
                                            value: _vm.fromTemplate,
                                            callback: function($$v) {
                                              _vm.fromTemplate = $$v
                                            },
                                            expression: "fromTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveFrom,
                                            callback: function($$v) {
                                              _vm.isSaveFrom = $$v
                                            },
                                            expression: "isSaveFrom"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isSaveFrom
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md2: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleParseAddress(
                                                      "isShowFromParseAddress",
                                                      "parseFormAddress",
                                                      _vm.from
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("parseAddress"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _vm.isSaveFrom
                                              ? _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "addressName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Site name"
                                                      ),
                                                      _vm.validAddressSiteName(
                                                        _vm.isSaveFrom,
                                                        _vm.isSaveSoldTo,
                                                        _vm.thirdPartyInfo,
                                                        _vm.isSaveTo,
                                                        _vm.to
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.siteName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "siteName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.siteName"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowFromParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.parseFormAddress,
                                            callback: function($$v) {
                                              _vm.parseFormAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseFormAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportFromExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportFromExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "phone"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportFromExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.from
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.from,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "from.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.from.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("Address1", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _vm.fromStates.length
                                                  ? _c("vite-autocomplete", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        items: _vm.fromStates,
                                                        label: _vm.$t("state"),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "State"
                                                          ),
                                                          function(v) {
                                                            return (
                                                              !_vm.fromStates.includes(
                                                                v
                                                              ) &&
                                                              "must be in " +
                                                                _vm.fromStates
                                                            )
                                                          }
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.from.state,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "from.state"
                                                      }
                                                    })
                                                  : _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t("state")
                                                      },
                                                      model: {
                                                        value: _vm.from.state,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "state",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "from.state"
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("zipCode")
                                          },
                                          model: {
                                            value: _vm.from.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "zipCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _vm.isDHL
                                              ? _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("vite-autocomplete", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        items:
                                                          _vm.fromTaxNumberTypes,
                                                        "item-text": "name",
                                                        "item-value": "value",
                                                        label: _vm.$t(
                                                          "taxNumberType"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.from
                                                            .taxNumberType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "taxNumberType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.taxNumberType"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              _vm._b(
                                                {},
                                                "v-flex",
                                                [_vm.isDHL ? "xs5" : "xs7"],
                                                false
                                              ),
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.from.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.allowedCountriesItems,
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country"),
                                            rules: [
                                              function(v) {
                                                return (
                                                  !_vm.allowedCountries.includes(
                                                    v
                                                  ) &&
                                                  "must be in " +
                                                    _vm.allowedCountries
                                                )
                                              }
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "from.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isDHL && _vm.from.taxNumberType
                                  ? _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "taxNumber"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired()
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.from.taxNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "taxNumber",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.taxNumber"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("vite-autocomplete", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        items:
                                                          _vm.countryCodeArray,
                                                        "item-text": "name",
                                                        "item-value": "value",
                                                        label: _vm.$t(
                                                          "taxNumberCountry"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired()
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.from
                                                            .taxNumberCountry,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "taxNumberCountry",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.taxNumberCountry"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-flex", { attrs: { xs4: "" } })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("recipient")) + ": "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.addresses,
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "siteName"
                                          },
                                          model: {
                                            value: _vm.toTemplate,
                                            callback: function($$v) {
                                              _vm.toTemplate = $$v
                                            },
                                            expression: "toTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveTo,
                                            callback: function($$v) {
                                              _vm.isSaveTo = $$v
                                            },
                                            expression: "isSaveTo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isSaveTo
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md2: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleParseAddress(
                                                      "isShowToParseAddress",
                                                      "parseToAddress",
                                                      _vm.to
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("parseAddress"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _vm.isSaveTo
                                          ? _c("v-text-field", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("addressName"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Site name"
                                                  ),
                                                  _vm.validAddressSiteName(
                                                    _vm.isSaveTo,
                                                    _vm.isSaveFrom,
                                                    _vm.from,
                                                    _vm.isSaveSoldTo,
                                                    _vm.thirdPartyInfo
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.siteName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "siteName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.siteName"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowToParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.parseToAddress,
                                            callback: function($$v) {
                                              _vm.parseToAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseToAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportToExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportToExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "phone"
                                                            )
                                                          },
                                                          model: {
                                                            value: _vm.to.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportToExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.to
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.to,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "to.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.to.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("address", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("vite-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.states,
                                                    label: _vm.$t("state"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "State"
                                                      )
                                                    ]
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(data) {
                                                        return [
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        data.item
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          data.item
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.to.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "to.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-around": "",
                                              "align-baseline": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("zipCode"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Zip code"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "zipCode",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.googleMapDisabled,
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.goToGoogleMapLink.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "location_on"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("googleMap")
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _vm.isDHL
                                              ? _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("vite-autocomplete", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        items:
                                                          _vm.toTaxNumberTypes,
                                                        "item-text": "name",
                                                        "item-value": "value",
                                                        label: _vm.$t(
                                                          "taxNumberType"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.to.taxNumberType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "taxNumberType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "to.taxNumberType"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              _vm._b(
                                                {},
                                                "v-flex",
                                                [_vm.isDHL ? "xs5" : "xs7"],
                                                false
                                              ),
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.to.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                name: _vm.$t("unitedStates"),
                                                value: "US"
                                              }
                                            ],
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country"),
                                            rules: [
                                              function(v) {
                                                return (
                                                  v !== "US" && "must be us"
                                                )
                                              }
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "to.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isDHL && _vm.to.taxNumberType
                                  ? _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "taxNumber"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired()
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.to.taxNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "taxNumber",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "to.taxNumber"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("vite-autocomplete", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        items:
                                                          _vm.countryCodeArray,
                                                        "item-text": "name",
                                                        "item-value": "value",
                                                        label: _vm.$t(
                                                          "taxNumberCountry"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired()
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.to
                                                            .taxNumberCountry,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "taxNumberCountry",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "to.taxNumberCountry"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t(
                                                  "taxesPaidAmount"
                                                ),
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      isNaN(v) &&
                                                      _vm.$t("fieldIsNumber", {
                                                        fieldName: "This field"
                                                      })
                                                    )
                                                  },
                                                  _vm.fieldIsRequired()
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.taxesPaidAmount,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "taxesPaidAmount",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "to.taxesPaidAmount"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isFEDEX && ["CA"].includes(_vm.from.countryCode)
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "title",
                                        attrs: {
                                          "align-baseline": "",
                                          "justify-space-between": ""
                                        }
                                      },
                                      [
                                        _c("v-flex", { attrs: { md2: "" } }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("exportDetail")) +
                                              ":\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("permitNumber"),
                                                rules: [
                                                  // fieldIsRequired('permitNumber'),
                                                  _vm.fieldCharRange(
                                                    "permitNumber",
                                                    5,
                                                    10
                                                  )
                                                ]
                                              },
                                              model: {
                                                value:
                                                  _vm.exportDetail.permitNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.exportDetail,
                                                    "permitNumber",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "exportDetail.permitNumber"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c("vite-autocomplete", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.cedFilings,
                                                "item-text": "label",
                                                "item-value": "value",
                                                label: _vm.$t("cedFiling"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "cedFiling"
                                                  )
                                                ]
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item",
                                                    fn: function(data) {
                                                      return [
                                                        [
                                                          _c(
                                                            "v-list-tile-content",
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      data.item
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        data.item
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2156570922
                                              ),
                                              model: {
                                                value:
                                                  _vm.exportDetail.cedFiling,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.exportDetail,
                                                    "cedFiling",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "exportDetail.cedFiling"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            _c("vite-autocomplete", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.exemptionNumbers,
                                                label: _vm.$t(
                                                  "exemptionNumber"
                                                ),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "exemptionNumber"
                                                  )
                                                ]
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item",
                                                    fn: function(data) {
                                                      return [
                                                        [
                                                          _c(
                                                            "v-list-tile-content",
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      data.item
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        data.item
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2156570922
                                              ),
                                              model: {
                                                value:
                                                  _vm.exportDetail
                                                    .exemptionNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.exportDetail,
                                                    "exemptionNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "exportDetail.exemptionNumber"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-flex", { attrs: { xs2: "" } })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isFEDEX
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "title",
                                        attrs: { "align-baseline": "" }
                                      },
                                      [
                                        _c("v-flex", { attrs: { xs2: "" } }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("thirdParty")) +
                                              ":\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("v-checkbox", {
                                              staticClass: "thirdPartySold",
                                              attrs: {
                                                "hide-details": true,
                                                label: _vm.$t("thirdPartySold")
                                              },
                                              model: {
                                                value: _vm.isThirdParty,
                                                callback: function($$v) {
                                                  _vm.isThirdParty = $$v
                                                },
                                                expression: "isThirdParty"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isThirdParty
                                          ? [
                                              _c(
                                                "v-flex",
                                                { attrs: { md2: "" } },
                                                [
                                                  _c("vite-autocomplete", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      items: _vm.addresses,
                                                      name:
                                                        "address-template-name",
                                                      "return-object": "",
                                                      label: _vm.$t(
                                                        "addressName"
                                                      ),
                                                      "item-text": "siteName",
                                                      "item-value": "key"
                                                    },
                                                    model: {
                                                      value: _vm.soldToTemplate,
                                                      callback: function($$v) {
                                                        _vm.soldToTemplate = $$v
                                                      },
                                                      expression:
                                                        "soldToTemplate"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { md2: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "checkbox",
                                                    attrs: {
                                                      "hide-details": "",
                                                      label: _vm.$t("save")
                                                    },
                                                    model: {
                                                      value: _vm.isSaveSoldTo,
                                                      callback: function($$v) {
                                                        _vm.isSaveSoldTo = $$v
                                                      },
                                                      expression: "isSaveSoldTo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { md4: "" } },
                                                [
                                                  _vm.isSaveSoldTo
                                                    ? _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: _vm.$t(
                                                            "addressName"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              "Site name"
                                                            ),
                                                            _vm.validAddressSiteName(
                                                              _vm.isSaveSoldTo,
                                                              _vm.isSaveFrom,
                                                              _vm.from,
                                                              _vm.isSaveTo,
                                                              _vm.to
                                                            )
                                                          ]
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.thirdPartyInfo
                                                              .siteName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.thirdPartyInfo,
                                                              "siteName",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "thirdPartyInfo.siteName"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm.isThirdParty
                                      ? [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-space-between":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "required_field",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "fullName"
                                                              ),
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "Full name"
                                                                ),
                                                                _vm.fieldCharRange(
                                                                  "Full name",
                                                                  3,
                                                                  35
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .thirdPartyInfo
                                                                  .fullName,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.thirdPartyInfo,
                                                                  "fullName",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "thirdPartyInfo.fullName"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "phone"
                                                              ),
                                                              rules: [
                                                                _vm.fieldCharLength(
                                                                  "phone",
                                                                  10
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .thirdPartyInfo
                                                                  .phone,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.thirdPartyInfo,
                                                                  "phone",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "thirdPartyInfo.phone"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      label: _vm.$t(
                                                        "companyName"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.thirdPartyInfo
                                                          .company,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.thirdPartyInfo,
                                                          "company",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "thirdPartyInfo.company"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "required_field",
                                                    attrs: {
                                                      "hide-details": "",
                                                      label:
                                                        _vm.$t("address") +
                                                        " 1",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          "Address"
                                                        ),
                                                        _vm.fieldCharLimit(
                                                          "address",
                                                          50
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.thirdPartyInfo
                                                          .address1,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.thirdPartyInfo,
                                                          "address1",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "thirdPartyInfo.address1"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      label:
                                                        _vm.$t("address") +
                                                        " 2",
                                                      rules: [
                                                        _vm.fieldCharLimit(
                                                          "Address2",
                                                          50
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.thirdPartyInfo
                                                          .address2,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.thirdPartyInfo,
                                                          "address2",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "thirdPartyInfo.address2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-space-between":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "required_field",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "city"
                                                              ),
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "City"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .thirdPartyInfo
                                                                  .city,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.thirdPartyInfo,
                                                                  "city",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "thirdPartyInfo.city"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c(
                                                            "vite-autocomplete",
                                                            {
                                                              staticClass:
                                                                "required_field",
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                items:
                                                                  _vm.states,
                                                                label: _vm.$t(
                                                                  "state"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldIsRequired(
                                                                    "State"
                                                                  )
                                                                ]
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key: "item",
                                                                    fn: function(
                                                                      data
                                                                    ) {
                                                                      return [
                                                                        [
                                                                          _c(
                                                                            "v-list-tile-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-tile-title",
                                                                                {
                                                                                  attrs: {
                                                                                    id:
                                                                                      data.item
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                  " +
                                                                                      _vm._s(
                                                                                        data.item
                                                                                      ) +
                                                                                      "\n                                "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                944430634
                                                              ),
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .thirdPartyInfo
                                                                    .state,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.thirdPartyInfo,
                                                                    "state",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "thirdPartyInfo.state"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-space-around":
                                                          "",
                                                        "align-baseline": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "required_field",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "zipCode"
                                                              ),
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "Zip code"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .thirdPartyInfo
                                                                  .zipCode,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.thirdPartyInfo,
                                                                  "zipCode",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "thirdPartyInfo.zipCode"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                top: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var on =
                                                                        ref.on
                                                                      return [
                                                                        _c(
                                                                          "v-btn",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  _vm.googleMapDisabled,
                                                                                icon:
                                                                                  "",
                                                                                flat:
                                                                                  "",
                                                                                color:
                                                                                  "primary",
                                                                                small:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.goToGoogleMapLink.apply(
                                                                                    null,
                                                                                    arguments
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "location_on"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                1480372903
                                                              )
                                                            },
                                                            [
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "googleMap"
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-space-between":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "email"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .thirdPartyInfo
                                                                  .email,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.thirdPartyInfo,
                                                                  "email",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "thirdPartyInfo.email"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs5: "" } },
                                                        [
                                                          _c(
                                                            "vite-autocomplete",
                                                            {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                items:
                                                                  _vm.fedexTaxTypes,
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "value",
                                                                label: _vm.$t(
                                                                  "taxNumberType"
                                                                )
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .thirdPartyInfo
                                                                    .taxNumberType,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.thirdPartyInfo,
                                                                    "taxNumberType",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "thirdPartyInfo.taxNumberType"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c("vite-autocomplete", {
                                                    staticClass:
                                                      "required_field",
                                                    attrs: {
                                                      "hide-details": "",
                                                      items: [
                                                        {
                                                          name: _vm.$t(
                                                            "unitedStates"
                                                          ),
                                                          value: "US"
                                                        }
                                                      ],
                                                      "item-text": "name",
                                                      "item-value": "value",
                                                      label: _vm.$t("country"),
                                                      rules: [
                                                        function(v) {
                                                          return (
                                                            v !== "US" &&
                                                            "must be us"
                                                          )
                                                        }
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.thirdPartyInfo
                                                          .countryCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.thirdPartyInfo,
                                                          "countryCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "thirdPartyInfo.countryCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.thirdPartyInfo.taxNumberType
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "justify-space-between": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs7: "" } },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            "justify-space-between":
                                                              ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { xs5: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    "hide-details":
                                                                      "",
                                                                    label: _vm.$t(
                                                                      "taxNumber"
                                                                    ),
                                                                    rules: [
                                                                      _vm.fieldIsRequired(
                                                                        "taxNumber"
                                                                      )
                                                                    ]
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .thirdPartyInfo
                                                                        .taxNumber,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.thirdPartyInfo,
                                                                        "taxNumber",
                                                                        typeof $$v ===
                                                                          "string"
                                                                          ? $$v.trim()
                                                                          : $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "thirdPartyInfo.taxNumber"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c("EeiPackageWidget", {
                                  ref: "EeiPackageWidget",
                                  attrs: {
                                    packages: _vm.packages,
                                    noteMemoSignature: _vm.noteMemoSignature,
                                    shipmentPurpose: _vm.shipmentPurpose,
                                    shippingService: _vm.shippingService,
                                    bookingConfirmationNumber:
                                      _vm.bookingConfirmationNumber,
                                    batteryLabel: _vm.batteryLabel,
                                    freightCharges: _vm.freightCharges,
                                    isImportToUS: ""
                                  },
                                  on: {
                                    "update:packages": function($event) {
                                      _vm.packages = $event
                                    },
                                    "update:shippingService": function($event) {
                                      _vm.shippingService = $event
                                    },
                                    "update:shipping-service": function(
                                      $event
                                    ) {
                                      _vm.shippingService = $event
                                    },
                                    selectTemplate: _vm.selectTemplate
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !!_vm.isFedexCarrier
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "title",
                                        staticStyle: { "min-height": "56px" },
                                        attrs: {
                                          "align-baseline": "",
                                          "justify-space-between": ""
                                        }
                                      },
                                      [
                                        _c("v-flex", { attrs: { xs1: "" } }, [
                                          _vm._v(
                                            "\n                  ETD:\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { grow: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass:
                                                  "etd-checkbox-container",
                                                attrs: { "align-center": "" }
                                              },
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "checkbox",
                                                  attrs: {
                                                    label: _vm.$t("ETDLabel"),
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: _vm.isEnabledETD,
                                                    callback: function($$v) {
                                                      _vm.isEnabledETD = $$v
                                                    },
                                                    expression: "isEnabledETD"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      top: "",
                                                      "max-width": "300px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              cursor: "pointer"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          help_outline\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "normal",
                                                          "line-height": "1.4"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t("ETDInfo")
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-flex", {
                                          attrs: { md8: "", xs8: "" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "compact compact-layout", attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "compact-card",
                            attrs: { width: "100%" }
                          },
                          [
                            _c(
                              "v-card-text",
                              { staticClass: "compact-card-text" },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    staticClass: "title compact-layout",
                                    attrs: {
                                      "align-baseline": "",
                                      "justify-start": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.$t("commodityInfo")) +
                                        ":\n                  "
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "ml-4": "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs6: "" } },
                                              [
                                                _c("v-combobox", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "commodityTemplate"
                                                    ),
                                                    items:
                                                      _vm.commodityTemplates,
                                                    "item-text": "name",
                                                    "item-value": "key",
                                                    clearable: ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onSelectCommodityTemplate
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs4: "" } },
                                              [
                                                _c("v-text-field", {
                                                  ref: "newTemplateNameInput",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "newTemplateName"
                                                    )
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.saveCommodityTemplate.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.newTemplateName,
                                                    callback: function($$v) {
                                                      _vm.newTemplateName =
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                    },
                                                    expression:
                                                      "newTemplateName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    loading:
                                                                      _vm.isSavingTemplate,
                                                                    disabled:
                                                                      _vm.isSavingTemplate
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.saveCommodityTemplate
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v("save")
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "saveAsTemplate"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.commodityErrorMessage
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "red--text font-weight-bold text-xs-right"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.commodityErrorMessage
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-table", {
                                  staticClass: "elevation-2 mt-2",
                                  attrs: {
                                    headers: _vm.commodityHeaders,
                                    items: _vm.commodities,
                                    "hide-actions": ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "headerCell",
                                      fn: function(props) {
                                        return [
                                          props.header.value === "action"
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary",
                                                                          flat:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                          icon:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            _vm.addEmptyCommodity
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "add"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t("add")
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(props.header.text)
                                                )
                                              ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "tr",
                                            {
                                              staticClass: "commodity-row",
                                              class: {
                                                editing:
                                                  _vm.editingRowIndex ===
                                                  props.index
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editRow(
                                                    props.index,
                                                    $event
                                                  )
                                                },
                                                mouseleave: _vm.onRowMouseLeave
                                              }
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "error",
                                                                        flat:
                                                                          "",
                                                                        small:
                                                                          "",
                                                                        icon:
                                                                          "",
                                                                        disabled:
                                                                          _vm
                                                                            .commodities
                                                                            .length ===
                                                                            1 ||
                                                                          _vm.isCommodityUnchangeable
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteCommodity(
                                                                            props.index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "delete"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("delete")
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "",
                                                                        disabled:
                                                                          props
                                                                            .item
                                                                            .isLoading,
                                                                        loading:
                                                                          props
                                                                            .item
                                                                            .isLoading
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.saveCommodityProfile(
                                                                            props.item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "article"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "saveCommodityTemplate"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { row: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "table-item",
                                                        staticStyle: {
                                                          "max-width": "200px"
                                                        },
                                                        attrs: {
                                                          value:
                                                            props.item
                                                              .selectedCommodity,
                                                          items:
                                                            _vm.mergedCommoditiesList,
                                                          "item-text":
                                                            "scheduleBDescription",
                                                          "item-value":
                                                            "scheduleBDescription",
                                                          filter:
                                                            _vm.customCommodityFilter,
                                                          clearable: "",
                                                          label: _vm.$t(
                                                            "commodity"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "commodities"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t(
                                                                "commodity"
                                                              )
                                                            )
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index,
                                                          "return-object": ""
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComboboxChangeByCommodities(
                                                              $event,
                                                              props.index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComboboxChangeByCommodities(
                                                              $event,
                                                              props.index
                                                            )
                                                          }
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "selection",
                                                              fn: function(
                                                                data
                                                              ) {
                                                                return [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .scheduleBDescription ||
                                                                          data
                                                                            .item
                                                                            .description
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              }
                                                            },
                                                            {
                                                              key: "item",
                                                              fn: function(
                                                                data
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "v-list-tile-content",
                                                                    {
                                                                      staticStyle: {
                                                                        "max-width":
                                                                          "300px",
                                                                        "white-space":
                                                                          "normal"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-tile-title",
                                                                        {
                                                                          staticStyle: {
                                                                            "white-space":
                                                                              "normal",
                                                                            "word-wrap":
                                                                              "break-word"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .item
                                                                                .scheduleBDescription ||
                                                                                data
                                                                                  .item
                                                                                  .description
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-list-tile-sub-title",
                                                                        {
                                                                          staticStyle: {
                                                                            "white-space":
                                                                              "normal",
                                                                            "word-wrap":
                                                                              "break-word"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                Code: " +
                                                                              _vm._s(
                                                                                data
                                                                                  .item
                                                                                  .scheduleBCode
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            },
                                                            {
                                                              key: "no-data",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "v-list-tile",
                                                                    [
                                                                      _c(
                                                                        "v-list-tile-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-tile-title",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "noDataAvailable"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "table-item",
                                                        staticStyle: {
                                                          "max-width": "250px"
                                                        },
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "description"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "description"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t(
                                                                "description"
                                                              )
                                                            ),
                                                            _vm.fieldCharLimit(
                                                              "description",
                                                              35
                                                            )
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .scheduleBDescription,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "scheduleBDescription",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.scheduleBDescription"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { row: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "table-item required_field",
                                                        attrs: {
                                                          items:
                                                            _vm.countryCodeArray,
                                                          label: _vm.$t(
                                                            "countryOfOrigin"
                                                          ),
                                                          "item-text": "name",
                                                          "item-value": "value",
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t(
                                                                "countryOfOrigin"
                                                              )
                                                            )
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .countryOfOrigin,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "countryOfOrigin",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.countryOfOrigin"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "table-item required_field",
                                                        attrs: {
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              "HS Code"
                                                            ),
                                                            _vm.validateHsCode
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.onHarmonizedCodeInput(
                                                              props.item
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .harmonizedCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "harmonizedCode",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.harmonizedCode"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      staticClass:
                                                        "required_field pt-0 table-item qty_filed",
                                                      attrs: {
                                                        rules: [
                                                          _vm.fieldIsRequired(),
                                                          _vm.fieldIsInteger(),
                                                          _vm.fieldIsOverZero()
                                                        ],
                                                        label: _vm.$t(
                                                          "quantity"
                                                        ),
                                                        suffix: _vm.isUnitValid(
                                                          props.item
                                                        )
                                                          ? _vm.getQtySuffix(
                                                              props.item
                                                            )
                                                          : "",
                                                        disabled:
                                                          _vm.editingRowIndex !==
                                                          props.index
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.onQuantityInput(
                                                            props.item
                                                          )
                                                        }
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.quantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "quantity",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.quantity"
                                                      }
                                                    },
                                                    [
                                                      !_vm.isUnitValid(
                                                        props.item
                                                      )
                                                        ? _c(
                                                            "template",
                                                            {
                                                              slot:
                                                                "append-outer"
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "qty_unit",
                                                                  attrs: {
                                                                    items:
                                                                      _vm.inShowChannelUnionList,
                                                                    clearable:
                                                                      "",
                                                                    rules: [
                                                                      _vm.fieldIsRequired(
                                                                        _vm.$t(
                                                                          "unit"
                                                                        )
                                                                      )
                                                                    ],
                                                                    "item-text":
                                                                      "text",
                                                                    "item-value":
                                                                      "key",
                                                                    label: _vm.$t(
                                                                      "unit"
                                                                    ),
                                                                    disabled:
                                                                      _vm.editingRowIndex !==
                                                                      props.index
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      props.item
                                                                        .selectedUnit,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        props.item,
                                                                        "selectedUnit",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "props.item.selectedUnit"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      prefix: "$",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("price")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("price")
                                                        ),
                                                        _vm.fieldIsInteger(
                                                          _vm.$t("price")
                                                        )
                                                      ],
                                                      disabled:
                                                        _vm.editingRowIndex !==
                                                          props.index ||
                                                        _vm.isCommodityUnchangeable
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.onPriceInput(
                                                          props.item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: props.item.price,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "price",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.price"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      value:
                                                        props.item.customsValue,
                                                      prefix: "$",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("customsValue")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("customsValue")
                                                        )
                                                      ],
                                                      disabled: true
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      suffix: _vm.isMeasurementMetric
                                                        ? "kg"
                                                        : "Lbs",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("totalWeight")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("totalWeight")
                                                        )
                                                      ],
                                                      disabled:
                                                        _vm.editingRowIndex !==
                                                        props.index
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .commodityWeight,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "commodityWeight",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.commodityWeight"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: { "justify-end": "", "align-baseline": "" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "mb-2 font-weight-bold text-xs-right",
                                staticStyle: {
                                  "font-size": "16px",
                                  "background-color": "yellow"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Rate does not include duties & taxes, clearance entry fees or other import fees.\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs7: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.getRate.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("getRate")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md9: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _vm.isLoadingRates
                                              ? _c(
                                                  "v-flex",
                                                  { attrs: { md2: "" } },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "primary"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-flex",
                                                  { attrs: { md10: "" } },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          row: "",
                                                          "no-wrap": "",
                                                          "text-xs-center": ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "baseCharge"
                                                              )
                                                            ) +
                                                            ": $                \n                        "
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "activator",
                                                                  fn: function(
                                                                    tooltip
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        _vm._g(
                                                                          {},
                                                                          tooltip.on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .displayRate
                                                                                  .rate ||
                                                                                  "----"
                                                                              ) +
                                                                              "\n                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            )
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm
                                                                    .displayRate
                                                                    .originBaseCharge
                                                                    ? Math.round(
                                                                        (100 *
                                                                          (_vm
                                                                            .displayRate
                                                                            .originBaseCharge -
                                                                            _vm
                                                                              .displayRate
                                                                              .rate)) /
                                                                          _vm
                                                                            .displayRate
                                                                            .originBaseCharge
                                                                      ) +
                                                                        1 +
                                                                        "% off"
                                                                    : "---"
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "surcharge"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .surcharge ===
                                                                      null
                                                                      ? "----"
                                                                      : _vm
                                                                          .displayRate
                                                                          .surcharge
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .hasResidentialCheck
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticStyle: {
                                                                  color: "blue"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      _vm
                                                                        .displayRate
                                                                        .isResidential
                                                                        ? "residential"
                                                                        : "commercial"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "total"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .rate
                                                                      ? _vm.toMoney(
                                                                          _vm
                                                                            .displayRate
                                                                            .rate +
                                                                            _vm
                                                                              .displayRate
                                                                              .surcharge
                                                                        )
                                                                      : "----"
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                           \n                        "
                                                        ),
                                                        _vm.displayRate
                                                          .estimatedDelivery &&
                                                        _vm.displayRate
                                                          .estimatedDelivery !==
                                                          "N/A" &&
                                                        ![
                                                          "xs",
                                                          "sm",
                                                          "md"
                                                        ].includes(
                                                          _vm.$vuetify
                                                            .breakpoint.name
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "estDelivery"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.formatEstDeliveryDate(
                                                                      _vm
                                                                        .displayRate
                                                                        .estimatedDelivery
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.rates.length > 1 && !_vm.isLoadingRates
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "subheading font-weight-bold",
                                            attrs: { md2: "" }
                                          },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  "nudge-width": 200,
                                                  "offset-x": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "moreRates"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1243220067
                                                ),
                                                model: {
                                                  value: _vm.moreRatesToggle,
                                                  callback: function($$v) {
                                                    _vm.moreRatesToggle = $$v
                                                  },
                                                  expression: "moreRatesToggle"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "v-card",
                                                  [
                                                    _c(
                                                      "v-card-text",
                                                      [
                                                        _c("v-data-table", {
                                                          attrs: {
                                                            headers: [
                                                              {
                                                                text: _vm.$t(
                                                                  "service"
                                                                ),
                                                                align: "left",
                                                                sortable: false,
                                                                value:
                                                                  "serviceType"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "discountCharge"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value: "rate"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "surcharge"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value:
                                                                  "surcharge"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "total"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value: "total"
                                                              },
                                                              {
                                                                text: _vm.$t(
                                                                  "estDelivery"
                                                                ),
                                                                align: "left",
                                                                sortable: false,
                                                                value: ""
                                                              }
                                                            ],
                                                            items: _vm.rates,
                                                            "item-key":
                                                              "serviceType",
                                                            "hide-actions": ""
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "items",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var item =
                                                                    ref.item
                                                                  return [
                                                                    _c("td", [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            linkify:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function() {
                                                                              _vm.$refs[
                                                                                "EeiPackageWidget"
                                                                              ].shippingService =
                                                                                item.serviceType ===
                                                                                "GROUND_HOME_DELIVERY"
                                                                                  ? "FEDEX_GROUND"
                                                                                  : item.serviceType
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.serviceDescription
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.rate
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.surcharge
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.total
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.formatEstDeliveryDate(
                                                                              item.estimatedDelivery
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ])
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            3189538796
                                                          )
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card-actions",
                                                      [
                                                        _c("v-spacer"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.moreRatesToggle = false
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Close")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.errorMessage
                          ? _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "red--text font-weight-bold text-xs-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Object.keys(_vm.warningMessages).length
                          ? _c("v-layout", { attrs: { "justify-end": "" } }, [
                              _c(
                                "span",
                                {
                                  staticClass: "font-weight-bold text-xs-right",
                                  staticStyle: { "background-color": "yellow" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Object.values(_vm.warningMessages).join(
                                          ", "
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7f6a0e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7f6a0e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelCreateImportToUsPopup.vue
// module id = null
// module chunks = 